<div class="container">
  <pre>{{ navigator | json }}</pre>
</div>
